<template>
  <div class="nc-datepicker" :class="{ 'nc-datepicker--disabled': disabled }">
    <label v-if="label" class="nc-datepicker__label">{{ label }}</label>
    <button class="nc-datepicker__trigger" @click="openPicker" :disabled="disabled">
      <mdicon name="calendar" size="16" class="nc-datepicker__icon" />
      <span class="nc-datepicker__value" :class="{ 'nc-datepicker__value--placeholder': !modelValue }">
        {{ displayValue }}
      </span>
      <mdicon v-if="modelValue && clearable" name="close-circle" size="16" class="nc-datepicker__clear" @click.stop="clear" />
    </button>
    <input
      ref="dateInput"
      type="date"
      :value="inputValue"
      class="nc-datepicker__native"
      @change="onDateChange"
    />
  </div>
</template>

<script>
export default {
  name: 'NcDatePicker',
  props: {
    modelValue: { type: String, default: '' },
    label: { type: String, default: '' },
    placeholder: { type: String, default: 'Kies datum...' },
    disabled: { type: Boolean, default: false },
    clearable: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  computed: {
    displayValue() {
      if (!this.modelValue) return this.placeholder;
      return new Date(this.modelValue).toLocaleDateString('nl-NL', {
        day: 'numeric', month: 'long', year: 'numeric',
      });
    },
    inputValue() {
      if (!this.modelValue) return '';
      return new Date(this.modelValue).toISOString().split('T')[0];
    },
  },
  methods: {
    openPicker() {
      this.$refs.dateInput.showPicker?.() || this.$refs.dateInput.click();
    },
    onDateChange(event) {
      this.$emit('update:modelValue', event.target.value);
    },
    clear() {
      this.$emit('update:modelValue', '');
    },
  },
};
</script>

<style scoped>
.nc-datepicker { padding: 0 4px; }
.nc-datepicker--disabled { opacity: 0.4; pointer-events: none; }
.nc-datepicker__label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--nc-text-secondary, #92949c);
  margin-bottom: 4px;
}
.nc-datepicker__trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  background: var(--nc-bg-input, #ffffff);
  border: 1px solid var(--nc-border, #e2e8f0);
  box-shadow: var(--nc-shadow-sm);
  border-radius: 8px;
  padding: 10px 12px;
  cursor: pointer;
  font-family: inherit;
  transition: border-color 0.15s ease;
}
.nc-datepicker__trigger:focus-within { border-color: var(--nc-color-primary, #14b69a); }
.nc-datepicker__icon { color: var(--nc-text-muted, #92949c); flex-shrink: 0; }
.nc-datepicker__value { flex: 1; font-size: 14px; color: var(--nc-text, #1a1a2e); text-align: left; }
.nc-datepicker__value--placeholder { color: var(--nc-text-placeholder, #b0b3b8); }
.nc-datepicker__clear { color: var(--nc-text-muted, #92949c); cursor: pointer; }
.nc-datepicker__native {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
  pointer-events: none;
}
</style>
